'use strict';

const MOBILE_NET_MODE = require('../../../../constant').MOBILE_NET_MODE;

function parse(reader) {
    reader.readUInt8("version");
    reader.readUInt8("data.mobile_type", value => MOBILE_NET_MODE[value]);
    reader.readString(16, "data.mobile_number");
    reader.readString(8, "data.mobile_pin_code");
    reader.readUInt32LE("data.periodic");
    reader.readUInt32LE("data.interval");

    reader.readFloatLE("data.aos_1.osh");
    reader.readFloatLE("data.aos_1.osl");
    reader.readFloatLE("data.aos_2.osh");
    reader.readFloatLE("data.aos_2.osl");
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/analog/params-report-parser.js